import { IPolygonData } from '@leafer-ui/interface'

import { LineData } from './LineData'


export class PolygonData extends LineData implements IPolygonData {

}